export default __webpack_public_path__ + "static/media/warning.aefd89fc.webp";